import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import ViewAttachmentPopup from '../../ViewAttachmentPopup';
import DocumentsListItem from './DocumentsListItem';
import FileUtil from '../../../helpers/FileUtil/FileUtil';
import dataModel from '../../../models/DataModel';

import './DocumentsList.scss';

export class DocumentsList extends BaseComponent {
  constructor(props) {
    super(props);
    DocumentsList.propTypes = {
      /* Mobile file open handler */
      handleOpenDoc: PropTypes.func,
      /* An array of documents to be displayed */
      documents: PropTypes.arrayOf(PropTypes.object),
      /* the type of document (e.g. 'reference'). Used in the display */
      documentType: PropTypes.string,
      /* whether delete is enabled */
      canDeleteDocuments: PropTypes.bool,
      /* delete handler */
      handleDeleteDocument: PropTypes.func,
    }; 
    DocumentsList.defaultProps = {
      documentType: '',
    };
    this.isMobile = dataModel.mobileBridge.isMobile;
    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: this.isMobile,
    });
  }

  handleCloseAttachmentPopup() {
    this.setState({ documentPopup: null });
  }

  handleDisplayDocument(document) {
    const width = window.innerWidth - 300;
    const height = window.innerHeight - 190;
    const imageWidth = width;
    const imageHeight = height - 60;
    const documentPopup = (
      <ViewAttachmentPopup 
        key={document.id}
        attachment={document} 
        handlePopupClose={this.handleCloseAttachmentPopup} 
        left={100} 
        top={100}
        width={width} 
        height={height} 
        imageWidth={imageWidth} 
        imageHeight={imageHeight}
      />
    );

    this.setState({ documentPopup });
    //log image download
    this.handleAnalytics(document);
  }

  handleOpenDoc(document) {
    this.handleAnalytics(document);
    this.props.handleOpenDoc(document);
  }
  
  handleAnalytics(document) {
    const extension = FileUtil.getExtension(document.name);

    const { documentType, parentComponentView } = this.props;

    let downloadEvent = '';
    if (parentComponentView == 'project') {
      downloadEvent += 'ProjectDetails';
    }
    else if (parentComponentView == 'task') {
      downloadEvent += 'TaskDetails';
    }

    if (documentType == 'project') {
      downloadEvent += 'UDViewed';
      this.analyticsLogger.logUniqueDocDownloadEvent(extension, downloadEvent);
    }
    else if (documentType == 'reference') {
      downloadEvent += 'RDViewed';
      this.analyticsLogger.logRDLDownloadEvent(extension, downloadEvent);
    }
    
  }

  createDocList() {
    const { documents } = this.props;
    return documents ? documents.map(doc => {
      if (doc) {
        return <DocumentsListItem
          displayDocument={this.handleDisplayDocument}
          document={doc}
          key={doc.id}
          handleOpenDoc={this.handleOpenDoc}
          canDeleteDocument={this.props.canDeleteDocuments}
          handleDeleteDocument={this.props.handleDeleteDocument}
        />;
      }
      return null;
    }) : [];
  }

  render() {
    const { documentType } = this.props;
    const docList = this.createDocList();

    const capitalizedDocumentType = documentType.length ? (documentType.charAt(0).toUpperCase() + documentType.slice(1)) : '';
    return (
      <div className="docs-container">
        {this.state.documentPopup}
          <span className="docs-container__title">{documentType.toUpperCase() + ' DOCUMENTS'}</span>
          <div className="doc-list">
            {
              docList && docList.length ? docList :
                <div className="empty-state">
                  {'No '+capitalizedDocumentType+' Documents found.'}
                </div>
            }
          </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users ? state.new_users.currentUser : null,
  };
};

export default connect(mapStateToProps)(DocumentsList);



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/DocumentsList/index.js